import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import index from '@/components/index'
import pcindex from '@/pccomponents/index'
import dd from '@/components/dd'
import Qx from '@/components/Qx'
import MenuQx from '@/components/MenuQx'
import Qua from '@/components/Qua'
import MenuQua from '@/components/MenuQua'
import qxfood from '@/components/qxfood'
import ss from '@/components/ss'
import qwe from '@/components/qwe'
import cscscs from '@/components/cscscs'
import shdc from '@/components/shdc'
import jh from '@/components/shjh'
import indexwt from '@/components/indexwt'
import indexs from '@/components/index6'
import Menu from '@/components/Menu'
import bzss from '@/components/bzss'
import VueRouter from 'vue-router'

Vue.use(Router)
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  mode:'hash',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/pcindex',
      name: 'pcindex',
      component: pcindex
    },
    {
      path: '/dd',
      name: 'dd',
      component: dd
    },
    {
      path: '/Qx',
      name: 'Qx',
      component: Qx
    },
	{
	  path: '/MenuQx',
	  name: 'MenuQx',
	  component: MenuQx
	},
    {
      path: '/Qua',
      name: 'Qua',
      component: Qua
    },
	{
	  path: '/MenuQua',
	  name: 'MenuQua',
	  component: MenuQua
	},
    {
      path: '/qxfood',
      name: 'qxfood',
      component: qxfood
    },
    {
      path: '/ss',
      name: 'ss',
      component: ss
    },
    {
      path: '/qwe',
      name: 'qwe',
      component: qwe
    },
    {
      path: '/cscscs',
      name: 'cscscs',
      component: cscscs
    },
    {
      path: '/index',
      name: 'shdc',
      component: shdc
    },
	{
	  path: '/indexwt',
	  name: 'indexwt',
	  component: indexwt
	},
    {
      path: '/jh',
      name: 'jh',
      component: jh
    },
	{
	  path: '/indexs',
	  name: 'indexs',
	  component: indexs
	},
	{
	  path: '/Menu',
	  name: 'Menu',
	  component: Menu
	},
	{
	  path: '/qrmenu',
	  name: 'bzss',
	  component: bzss
	},
	{
	  path: '/qrmenus',
	  name: 'bzss',
	  component: bzss
	},
	{
	  path: '/qrmenur',
	  name: 'bzss',
	  component: bzss
	},
  ],
  mode:"history"
})



// WEBPACK FOOTER //
// ./src/router/index.js